import React, { useEffect, useState } from "react"
import { userloginApi } from "../../doctorapi"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import {
    Form,
    Input,
    Container, Spinner,
} from 'reactstrap';
import { FullWrap, FormWrap, Heading, LoginButton, SignButton } from "./styles"
export const Userlogin = () => {
    const [loginValues, setLoginvalues] = useState({
        email: "",
        password: ""
    })
    const [isLoading, setIsLoading] = useState(false);
    toast.configure()

    useEffect(() => {
        document.body.classList.toggle("login-page")
    }, [])

    const Emailhandler = input => {
        let emailvalue = { ...loginValues, email: input.target.value }
        setLoginvalues(emailvalue)
    }
    const Passwordhandler = input => {
        let passwordvalue = { ...loginValues, password: input.target.value }
        setLoginvalues(passwordvalue)
    }
    let history = useHistory()
    const handlesubmit = () => {
        if (loginValues.email === "" || loginValues.password === "") {
            notify("error")
        } else {
            setIsLoading(true);
            userloginApi(loginValues).then(response => {
                setIsLoading(false);
                if (response.data.statusCode === 200) {
                    localStorage.setItem("token", JSON.stringify(response.data.body.token))
                    history.push("/user")
                    notify("success")
                } else {
                    notify("error")
                }
            }).catch(error => {
                setIsLoading(false);
                console.log("error", error)
                notify("loginerror")
            })
        }
    }
    const notify = msg => {
        if (msg == "error") {
            toast.error("Please fill the data")
        } else if (msg == "success") {
            // toast.success("User Login Successfully")
        } else if (msg == "loginerror") {
            toast.error("Invalid Email or Password")
        }
    }

    const handleAdminlogin =() => {
        history.push('/login')
    }
    const handleSignup =() => {
        history.push('/usersignup')
    }
    const handleForgotPassword =() => {
        history.push('/forgotpassword')
    }
    return (
        <FullWrap>
            <Container>
                <FormWrap>
                    <Form
                        action=""
                        className="form"
                        method=""
                        autocomplete="off"
                    // onSubmit={e => handlesubmit(e)}
                    >
                        <Heading>Login as User</Heading>
                        <Input
                            placeholder="Email"
                            type="text"
                            onChange={e => Emailhandler(e, "email")}
                        />
                        <Input
                            placeholder="Password"
                            type="password"
                            autoComplete="new-password"
                            onChange={e => Passwordhandler(e, "password")}
                        />
                        <LoginButton
                            block
                            // href="#"
                            onClick={e => handlesubmit(e)}
                            disabled={isLoading}
                        >
                            { isLoading ?
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                              : 'Login as User'
                            }

                    </LoginButton>
                    <LoginButton
                            block
                            // href="#"
                            onClick={() =>  handleAdminlogin()}
                        >
                            Go to Login As Admin
                    </LoginButton>
                        {/* <SignButton
                            block
                            onClick={() => handleSignup()}
                        >
                            Signup as User
                    </SignButton> */}
                    <SignButton
                            block
                            onClick={() => handleForgotPassword()}
                        >
                            Forgot Password as User
                    </SignButton>
                    </Form>
                </FormWrap>
            </Container>
        </FullWrap>
    )
}

export default Userlogin



// WEBPACK FOOTER //
// ./src/component/Userlogin/index.js